import { Labeled } from 'react-admin';
import { useTranslate } from 'ra-core';
import NegotiationCard from '../negotiation/NegotiationCard';
import { Offer } from '../types';
import { Button } from '@/components/ui/button';

type Props = {
  offer: Offer;
  onOpenHistory: () => void;
};

function OfferDrawerLastNegotiation({ offer, onOpenHistory }: Props) {
  const t = useTranslate();

  if (!offer.last_negotiation) return null;

  return (
    <Labeled
      label={
        <span className="flex flex-row justify-between items-center w-full">
          <span>{t('common.text.negotiations')}</span>
          <Button variant="ghost" size="sm" onClick={onOpenHistory}>
            {t('common.text.view_history')}
          </Button>
        </span>
      }
    >
      <NegotiationCard negotiation={offer.last_negotiation} />
    </Labeled>
  );
}

export default OfferDrawerLastNegotiation;
